import Icon from '@plone/volto/components/theme/Icon/Icon';
import { injectIntl } from 'react-intl';
import { Card, Segment } from 'semantic-ui-react';

import messages from '../../../../messages/columns';

// const messages = defineMessages({
//   selectLayout: {
//     id: 'Select layout',
//     defaultMessage: 'Select layout',
//   },
//   nColumns: {
//     id: 'N columns',
//     defaultMessage: '{numCols, plural, one {# column} other {# columns}}',
//   },
//   equal: {
//     id: 'equal',
//     defaultMessage: 'equal',
//   },
// });

const ColumnVariations = ({ onChange, variants, intl }) => {
  return (
    <Segment>
      <h4>{intl.formatMessage(messages.selectLayout)}:</h4>
      <Card.Group centered itemsPerRow={7}>
        {variants
          .sort(
            (a, b) =>
              a.defaultData.gridCols.length - b.defaultData.gridCols.length,
          )
          .map((variant, index) => {
            const { icon, defaultData, cols, title } = variant;

            return (
              <Card key={index} onClick={() => onChange(defaultData)}>
                <Card.Content>
                  <Icon name={icon} size="55px" />
                  {cols ? (
                    <p>
                      <div>
                        <strong>
                          {intl.formatMessage(messages.nColumns, {
                            numCols: cols,
                          })}
                        </strong>
                      </div>
                      <div>{title || intl.formatMessage(messages.equal)}</div>
                    </p>
                  ) : (
                    ''
                  )}
                </Card.Content>
              </Card>
            );
          })}
      </Card.Group>
    </Segment>
  );
};

export default injectIntl(ColumnVariations);
